export default "__VITE_ASSET__CCrCS8C7__"